"use client";

import { Box, Button, Flex, Link, Span, Stack, Text } from "@chakra-ui/react";
import { memo, useCallback } from "react";

interface Props {
  resentCount: number;
  resendEmailVerification?: () => void;
  loginWithOtherMethods: () => void;
}

const ResendEmail: React.FC<Props> = ({
  resentCount,
  resendEmailVerification,
  loginWithOtherMethods,
}) => {
  const resend = useCallback(() => {
    resendEmailVerification?.();
  }, [resendEmailVerification]);

  return (
    <Flex justify="center">
      <Box maxW="md" p={8}>
        <Stack gap={6}>
          <Text alignSelf="center" fontSize="2xl">
            Check your inbox
          </Text>
          <Text fontSize="sm" color="fg.muted">
            <Span fontWeight="bold">Please click on the link</Span> in the email we just sent you to
            confirm your email address.
          </Text>
          <Button
            onClick={resend}
            disabled={resentCount > 0}
            backgroundColor={resentCount > 0 ? "green" : undefined}
          >
            {resentCount === 0 ? "Resend verification email" : "Resent verification email"}
          </Button>
          <Link variant="underline" onClick={loginWithOtherMethods}>
            Log in with other methods
          </Link>
        </Stack>
      </Box>
    </Flex>
  );
};

export default memo(ResendEmail);
